import { Navigate, useLocation } from "react-router";
import type { AppModule } from "../types";

function ToSummary() {
  const { search } = useLocation();
  return <Navigate replace to={`/reports/summary${search}`} />;
}

/** Summary and Detailed reports (build-plan 6.7). The shell already places the REPORTS sidebar entry and flyout. */
export const reportsSummaryDetailedModule: AppModule = {
  name: "reports-summary-detailed",
  routes: {
    shell: [
      { path: "/reports", handle: { title: "Reports" }, element: <ToSummary /> },
      {
        path: "/reports/summary",
        handle: { title: "Reports" },
        lazy: () => import("./pages/SummaryPage").then((m) => ({ Component: m.SummaryPage })),
      },
      {
        path: "/reports/detailed",
        handle: { title: "Reports" },
        lazy: () => import("./pages/DetailedPage").then((m) => ({ Component: m.DetailedPage })),
      },
    ],
  },
};
